module.exports = __webpack_public_path__ + "img/cook_cover-01.d2ea8507.png";